import React from "react";
import { useQuery } from "@apollo/react-hooks";

import { GET_ABOUT_SECTION } from "../../../../services/graphql-query";
import { AboutProductPlaceholder } from "../Placeholders";

export default function AboutSection({ collectionName }) {
    const { loading: aboutLoading, data: aboutData } = useQuery(
        GET_ABOUT_SECTION,
        { variables: { name: collectionName } }
    );
    return (
        <>
            {aboutLoading ||
                (aboutData.collections.data[0].attributes.about_section && (
                    <div
                        className="py-4"
                        style={{
                            borderTop: "1px solid",
                            borderBottom: "1px solid",
                            borderColor: "rgba(185, 215, 15)",
                        }}
                    >
                        {aboutLoading ? (
                            <AboutProductPlaceholder />
                        ) : aboutData.collections.data[0].attributes
                              .about_section ? (
                            <>
                                <h2 className="text-uppercase fw-bold">
                                    {
                                        aboutData.collections.data[0].attributes
                                            .about_section.header
                                    }
                                </h2>
                                <p>
                                    {
                                        aboutData.collections.data[0].attributes
                                            .about_section.description
                                    }
                                </p>
                            </>
                        ) : (
                            <></>
                        )}
                    </div>
                ))}
        </>
    );
}
